import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, forwardRef } from '@angular/core';
import { Observable, map } from 'rxjs';
import { GLOBAL } from 'src/app/_config/config';
import { MessageError } from 'src/app/interfaces/lotes.interfaces';
import { TonsPerYard } from 'src/app/interfaces/tons-per-yard.interfaces';

/**
 * Servicio que gestiona las toneladas y piezas por patio (yarda) de un lote,
 * calculando los porcentajes correspondientes y permitiendo eliminar registros.
 */
@Injectable({
  providedIn: 'root'
})
export class TonsPerYardService {
  assignedTons: boolean = false;
  assignedPieces: boolean = false;
  locationsList: any[] = [];

  constructor(
    @Inject(forwardRef(() => HttpClient)) private http: HttpClient
  ) { }

  /**
   * Obtiene las toneladas y piezas por patio de un lote, calculando los
   * porcentajes de tonelaje y piezas y descartando los registros en cero.
   * @param module_id - Identificador del módulo.
   * @param batch_id - Identificador del lote.
   * @returns Observable con la lista de toneladas por patio.
   */
  getTonsPerYardList(module_id: number, batch_id: number): Observable<TonsPerYard[]> {
    const url: string = `${GLOBAL.url}${GLOBAL.tonsPerYard.list}`;
    return this.http.post<TonsPerYard[]>(url, {
      module_id,
      batch_id
    }).pipe(
      map( amountsPerYardList => {
        const totalTons = amountsPerYardList.reduce( (total, amount) => total + amount.tonnage, 0)
        const totalPieces = amountsPerYardList.reduce( (total, amount) => total + amount.pieces, 0)
        return amountsPerYardList.map( amountsPerYard => ({
          ...amountsPerYard,
          tonnage: Number(amountsPerYard.tonnage.toFixed(3)) || 0,
          tonnage_percentage: Number(((amountsPerYard.tonnage / totalTons) * 100).toFixed(2)) || 0,
          pieces_percentage: Number(((amountsPerYard.pieces / totalPieces) * 100).toFixed(2)) || 0,
        })).filter( amountsPerYard => {
          if (amountsPerYard.tonnage !== 0 || amountsPerYard.pieces !== 0)
            return true
          else
            return false
        });
      })
    );
  }

  /**
   * Elimina un registro de toneladas por patio.
   * @param id - Identificador del registro a eliminar.
   * @returns Observable con el resultado de la operación.
   */
  deleteYard(id: number): Observable<MessageError> {
    const url: string = `${GLOBAL.url}${GLOBAL.tonsPerYard.delete}${id}`;
    return this.http.delete<MessageError>(url);
  }
}
